import { gql } from "@apollo/client";

export const GET_DISPUTE_TRACKING_COMMUNICATIONS = gql`
  query DisputeTrackingCommunications($params: GetDisputeTrackingCommunicationsInput!) {
    disputeTrackingCommunications(params: $params) {
      disputeTrackerId
      items {
        authorName
        commentText
        messageType
        postedAt
      }
    }
  }
`;
